// Needs attention for ONE artist (ART-324) — the artist page's card. Band-scoped and keyed ['band', bandId,
// 'needs-attention'] so an artist switch scorches it; the hook calls the BAND-DIRECT path and the org-lens
// middleware splices `/orgs/{orgId}` under the roster shell. MONEY-FREE. Not enveloped.
import type { components } from "@cntrl/api-client";
import { useApp } from "../appContext.js";
import { useBandQuery } from "./useBandQuery.js";
import { ApiError } from "./apiError.js";

export type NeedsAttentionRead = components["schemas"]["NeedsAttentionRead"];
export type AttentionItem = components["schemas"]["AttentionItem"];

export function useNeedsAttention(enabled = true) {
  const { api } = useApp();
  return useBandQuery<NeedsAttentionRead>(
    ["needs-attention"],
    async (bandId) => {
      const { data, error, response } = await api.GET("/api/v1/bands/{bandId}/needs-attention", {
        params: { path: { bandId } },
      });
      if (!response.ok || !data) throw new ApiError(response.status, error);
      return data;
    },
    { enabled, staleTime: 60_000 },
  );
}
